export default {
	items: [
		{
			id: 'navigation',
			title: '',
			type: 'group',
			icon: 'icon-navigation',
			children: [
				{
					id: 'dashboard',
					title: 'Dashboard',
					type: 'item',
					url: '/admin/dashboard/home',
					icon: 'feather icon-home',
				},
				{
					id: 'profile',
					title: 'Profile',
					type: 'item',
					url: '/admin/dashboard/profile',
					icon: 'feather icon-user',
				},
				{
					id: 'campaigns',
					title: 'Campaigns',
					type: 'item',
					url: '/admin/dashboard/campaigns',
					icon: 'feather icon-circle',
				},
				{
					id: 'submissions',
					title: 'Submissions',
					type: 'item',
					url: '/admin/dashboard/submissions',
					icon: 'feather icon-upload-cloud',
				},
				{
					id: 'users',
					title: 'Users',
					type: 'item',
					url: '/admin/dashboard/users',
					icon: 'feather icon-users',
				},
				{
					id: 'professionals',
					title: 'Professionals',
					type: 'item',
					url: '/admin/dashboard/professionals',
					icon: 'feather icon-users',
				},
				{
					id: 'notifications',
					title: 'Notifications',
					type: 'item',
					url: '/admin/dashboard/notifications',
					icon: 'feather icon-alert-circle',
				},
			],
		},
	],
}
